import { useEffect } from 'react';

import { useRouter } from 'next/router';
import AnimateSpinner from '@components/animate-spinner';

const TrackableRedirect = ({ to }) => {
  const router = useRouter();

  useEffect(() => {
    router.push(to);
  }, [to]);

  return (
    <div className="py-[100px] flex justify-center">
      <AnimateSpinner />
    </div>
  );
};

export default TrackableRedirect;
